export default {
  book: {
    title: '예약 확인',
    trainInfo: '열차 정보',
    seatPreference: '선호하는 좌석',
    passengerInfo: '승객 정보',
    bookingNotice: '예약 전 주의사항',
    paymentConfirmation: '결제 전 확인 사항',
    soldOut: '매진',
    tip: '좌석 확보를 위해 가능한 한 신속히 결제를 완료해 주시기 바랍니다.',
    passenger: {
      count: '탑승인원',
      representative: '탑승자 대표',
      representativeTip: '（탑승자 1명의 정보만 입력하시면 됩니다.）',
      lastName: '성 (영문)',
      firstName: '이름 (영문)',
      email: '이메일 주소 (예약정보 발송용)'
    }
  },
  bookConfirm: {
    paymentInfo: '결제 정보',
    paymentConfirmation: {
      warningTitle: '취소 정책을 확인하세요:',
      warningText: '구매 후 반환할 수 없습니다.',
      agreementText: '위의 내용을 확인하였고, 동의합니다.'
    },
    paymentAmount: {
      total: '합계',
      details: '상세',
      note: '일본 엔화 이외의 통화로 표시되는 금액은 현재 환율을 기준으로 한 추정값이며, 실제 청구 금액과 다를 수 있습니다. 참고용으로 확인해 주시기 바랍니다.'
    }
  },
  bookResult: {
    successMessage:
      '예약이 완료되었습니다.\n주문 세부 정보에서 발권 결과를 확인하세요.'
  }
};
